var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('herocomponents'),_c('navbar'),_c('approach'),_c('Systems'),_c('br'),_c('br'),_c('br'),_c('br'),_c('Clients'),_c('br'),_c('Update'),_c('br'),_c('Contact'),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }